import React from "react";
import { removeUserSession } from "../utils/Common";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

const UnauthorizedAccess = () => {
  let navigate = useNavigate();
  removeUserSession();

  return (
    <div className="fetch-status-label">
      <div className="home-page-login">
        <p>Vaša sesija je istekla, molimo vas da se ponovno prijavite</p>
        <Button
          label="Prijavi se"
          icon="pi pi-sign-in "
          className="w-300 mt-3"
          onClick={() => {
            navigate("/login");
          }}
        />
        <small>Kliknite na gumb "Prijavi se" kako bi pristupili sustavu!</small>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;
